import { createFirebaseApp } from "@mattfinkel/common-web";

// The four values are read as STATIC dot accesses, and that shape is
// load-bearing rather than stylistic: Vite can only substitute an env
// reference it can resolve statically, and given a computed key it inlines the
// WHOLE `import.meta.env` object instead -- which also makes
// scripts/check-build-config.mjs's "was this value inlined?" check vacuous.
// The full account lives in `createFirebaseApp`'s doc comment.
//
// Everything else about Firebase initialization (blank/whitespace rejection,
// localStorage persistence, the explicit popup resolver, and the deliberate
// absence of getFirestore) now lives in @mattfinkel/common-web, so it cannot
// drift apart from the other apps in the fleet.
export const { firebaseApp, auth, googleProvider } = createFirebaseApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});
